<script>
import { INDUSTRY_TAGS, SKILL_TAGS } from '@/state/apollo/tags'
import goFetch from '@/utils/goFetch'

export default {
  name: 'ProvideTags',
  props: {
    tagType: {
      type: String,
      required: true,
      validator(type) {
        return ['skills', 'industries', 'jobTitles', 'fileTags'].includes(type)
      },
    },
    locale: {
      type: String,
      default: currentLanguageSelected ?? 'en',
    },
    /**
     * Weather to skip fetching the data initially.
     * If true flip it to false when you want the component to fetch the data
     */
    skip: {
      type: Boolean,
      default: false,
    },
    /**
     * Whether to include id and name in the query result ({id: 'some-id', name: 'tag name'}) or just a
     * flattened array of names (default)
     */
    includeId: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fetchRes: [],
      loading: false,
    }
  },
  apollo: {
    skills: {
      query: SKILL_TAGS,
      variables() {
        return {
          locale: this.locale,
        }
      },
      update(data) {
        return data.skills.data.map((tag) =>
          this.includeId
            ? {
                name: tag.name.toLowerCase(),
                id: tag.globalId,
              }
            : tag.name.toLowerCase(),
        )
      },
      skip() {
        return this.tagType !== 'skills' || this.skip
      },
    },
    industries: {
      query: INDUSTRY_TAGS,
      variables() {
        return {
          locale: this.locale,
        }
      },
      update(data) {
        return data.industries.data.map((tag) =>
          this.includeId
            ? {
                name: tag.name.toLowerCase(),
                id: tag.globalId,
              }
            : tag.name.toLowerCase(),
        )
      },
      skip() {
        return this.tagType !== 'industries' || this.skip
      },
    },
  },
  computed: {
    tags() {
      return [...new Set([...(this.skills ?? []), ...(this.industries ?? []), ...this.fetchRes])]
    },
  },
  created() {
    if (this.tagType === 'jobTitles') {
      this.getJobTitles()
    }
    if (this.tagType === 'fileTags') {
      this.fetchRes = ['default on contracts', 'contracts', 'conversations', 'archived']
    }
  },
  methods: {
    async getJobTitles() {
      this.loading = true
      this.fetchRes = await goFetch(`/jobtitles.txt?locale=${this.locale}`)
      this.loading = false
      // IE reads res.data as a string, and not as an array
      if (typeof this.fetchRes === 'string') {
        // Clean up the "string" and split it into an array
        this.fetchRes = this.fetchRes.replace('[', '').replace(']', '').replace(/"/g, '').split(',')
      }
    },
  },
  render() {
    return this.$slots.default({
      tags: this.tags,
      loading: this.$apollo.loading || this.loading,
    })
  },
}
</script>
